import { AfterViewInit, Directive, ElementRef, Injector, OnDestroy, OnInit } from "@angular/core";
import { FrameContext } from "@farris/devkit";
import { ListFilterComponent } from '@farris/ui-list-filter';
import { ComponentRef } from "./component-ref";
@Directive({
  selector: '[listFilterRef]'
})
export class ListFilterComponentRefDirective extends ComponentRef implements OnInit, OnDestroy, AfterViewInit {
  constructor(private injector: Injector, private component: ListFilterComponent, public elementRef: ElementRef, public frameContext: FrameContext) { 
    super(frameContext, elementRef);
  }
  ngAfterViewInit(): void {
    this.tryAddComponent(this.component);
  }
  ngOnInit(): void {
    this.addComponent(this.component);
  }
  ngOnDestroy(): void {
  }
}